import axios from "axios";
import config from "../config";

interface LogoutResponse {
  logout: boolean;
}

export const Logout = async () => {
  let isLoggedOut = false;
  try {
    const response = await axios.get<LogoutResponse>(
      config.logoutClearCookieEndpoint
    );
    console.log(JSON.stringify(response));
    if (response?.data?.logout) {
      isLoggedOut = true;
    }
  } catch (e) {
    console.error("There was an error!", e);
  }
  return isLoggedOut;
};
